import store from "@/store";
import { transformText } from "./textUtils";

export function getAllTranslations() {
    let useLang = store.getters.getUserLang || 'en';
    let translations = null;
    try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `/data/lang/${useLang}.json`, false);
        xhr.send();
        if (xhr.status === 200) {
            translations = JSON.parse(xhr.responseText);
            store.dispatch('saveTranslations', translations);
        }
    } catch (error) {
        translations = null;
    }
    return translations;
}

export function translate(text = '', textTransform = '') {
    if(!text || text == '')
        return text;
    try {
        const translations = getAllTranslations();
        if(translations[text] === undefined || translations[text] === null || translations[text] === '')
            return transformText(text, textTransform);
        return translations[text] === undefined || translations[text] === null
                ? transformText(text, textTransform)
                : transformText(translations[text], textTransform);
    } catch (error) {
        console.error(error);
        return text;
    }
}